import { Cell } from '@pelckmans/elementis/components/table';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@pelckmans/elementis/components/button';
import FilterOnIcon from '@pelckmans/elementis/icons/filter-on';
import FilterOffIcon from '@pelckmans/elementis/icons/filter-off';
import ModalContext from '../../../../../../contexts/ModalContext';
import ScorableItemFilterModal from '../../scorable-item-filter-modal/ScorableItemFilterModal';
import { useFilters } from '../../../context/filter-context/FilterContext';
import { ScorableItemTableDataGroup } from '../hooks/useTableData';
import Badge from '@pelckmans/elementis/components/badge';
import { useResultsDataContext } from '../../../context/ResultsDataContext';

interface Props {
  tableDataGroups: ScorableItemTableDataGroup[];
}

export default function ItemFilter({ tableDataGroups }: Props) {
  const { t } = useTranslation();
  const { scorableItemsPerSchoolYearPerModule } = useResultsDataContext();
  const { setSelectedScorableItems, selectedScorableItems, selectedSchoolYear, selectedModule, spScorableItemIds } =
    useFilters();
  const { showModal } = useContext(ModalContext);

  function handleFilterScorableItemsClick() {
    showModal(
      <ScorableItemFilterModal
        id="scorable-item-filter-modal"
        tableDataGroups={tableDataGroups}
        onConfirm={setSelectedScorableItems}
        selectedItemIds={spScorableItemIds}
      />,
    );
  }

  const allScorableItems =
    selectedSchoolYear && selectedModule
      ? scorableItemsPerSchoolYearPerModule[selectedSchoolYear.id]?.[selectedModule.id] || []
      : [];

  const scorableItemFilterActive =
    selectedScorableItems.length > 0 && selectedScorableItems.length !== allScorableItems.length;

  const clearLabel = t('PAGES.RESULTS.PER_STUDENT.FILTER.SCORABLE_ITEMS.CLEAR');

  return (
    <Cell.HeaderText.Actions>
      <Button
        onClick={handleFilterScorableItemsClick}
        startIcon={<FilterOnIcon data-testid="filter-scorable-item" />}
        prominence="neutral"
        badge={
          scorableItemFilterActive ? (
            <Badge prominence="ghost" size="sm">
              {selectedScorableItems.length}
            </Badge>
          ) : undefined
        }
        key="filter-scorable-items"
      >
        {t('ACTIONS.FILTER')}
      </Button>
      {scorableItemFilterActive && (
        <Button
          prominence="neutral"
          startIcon={<FilterOffIcon data-testid="filter-off-icon" />}
          aria-label={clearLabel}
          tooltip={clearLabel}
          onClick={() => setSelectedScorableItems([])}
          key="clear-students-filter"
        />
      )}
    </Cell.HeaderText.Actions>
  );
}
